import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Checkbox, Divider, FormControlLabel, Grid, Radio } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog.js";
import Notification from "../../components/Common/Notification.js";
import TablePageControl from "../../components/Common/TablePageControl.js";
import Helpers from "../../helpers/helpers.js";
import { getCreditListing, resetCreditState } from "../../store/actions.js";
import AppDialog from "../../components/Common/AppDialog.js";
import Table from "../../components/Common/Table.js";
import CustomSelect2 from "../../components/Form/CustomSelect2.js";

const Credit = ({ userPermission, creditListing, leftSideBarType, creditBalance }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [tabValue, setTabValue] = useState('all');
    const [filterObject, setFilterObject] = useState({ position: 'all', status: 'all', bannerType: 'all', date_range: 'all' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("10");
    const [search, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("start");
    const [selectedRow, setSelectedRow] = useState();
    const [selectedCredit, setSelectedCredit] = useState();
    const [selectedPayment, setSelectedPayment] = useState();
    const [paymentOpen, setPaymentOpen] = useState(false);
    const [confirmPaymentOpen, setConfirmPaymentOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [exportable, setExportable] = useState(true);
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);
    const [width, setWidth] = useState(window.innerWidth);
    const searchRef = useRef(search);

    useEffect(() => {
        dispatch(resetCreditState());
    }, [])

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-marketing") && setCreatable(true);
            userPermission?.includes("edit-marketing") && setEditable(true);
            userPermission?.includes("delete-marketing") && setDeletable(true);
            userPermission?.includes("export-marketing") && setExportable(true);
        }
    }, [userPermission]);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by, filterObject]);

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        if (checkedAll) {
            // let temp = vendorsListing && vendorsListing?.data?.length > 0 ? vendorsListing?.data?.map((x, idx) => x?.id) : []
            // setSelectedRow(temp)
        } else {
            setSelectedRow("")
        }

    }, [checkedAll]);

    const paymentTypeList = [
        { value: "stripe", label: "Stripe" },
        { value: "paynow", label: "Paynow" },
    ]

    const deleteCheckBox = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <div>
                        <Checkbox
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            checked={checkedAll ? checkedAll : selectedRow && selectedRow?.length > 0 && selectedRow?.includes(cellProps.id)}
                            sx={{
                                '&.Mui-checked': {
                                    color: "#a0a0a0",
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 18,
                                },
                            }}
                            value={cellProps.id}
                            onChange={(event) => handleCheckboxChange(event.target.value)} />
                    </div>
                )
            },
        },
    ]

    const header = [
        {
            Header: "Date",
            accessor: (cellProps) => {
                // 10 Oct 2025 03:16 PM
                return (cellProps?.created_at ? cellProps.created_at : "-")
            },
        },
        {
            Header: "Description",
            minWidth: 300,
            accessor: (cellProps) => {
                return (cellProps?.description ? cellProps.description : "-")
            },
        },
        {
            Header: 'Credits',
            accessor: (cellProps) => {
                return (cellProps?.credit || "-")
            },
        },
        // {
        //     Header: 'Price',
        //     accessor: (cellProps) => {
        //         return (cellProps?.price || "-")
        //     },
        // },
        // {
        //     Header: "Receipt",
        //     accessor: (cellProps) => {
        //         return (
        //             <ButtonBase style={{ borderRadius: 7, padding: 2 }}>
        //                 <Icon icon={'fluent:receipt-24-regular'} style={{ color: '#808588', marginLeft: 5, fontSize: 18 }} />
        //             </ButtonBase>
        //         )
        //     },
        // },
    ]

    const creditList = [
        { id: '90_credit', label: 90, credit: 90, price: 45 },
        { id: '180_credit', label: 180, credit: 180, price: 90 },
        { id: '360_credit', label: 360, credit: 360, price: 180 },
    ]

    const initData = () => {
        let payload = {
            page: page,
            length: length,
            search: searchRef.current,
            status: filterObject?.status !== 'all' ? filterObject?.status : '',
            date_range: filterObject?.date_range !== 'all' ? filterObject?.date_range : '',
        }
        dispatch(getCreditListing(payload));
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const handleCheckboxChange = (e) => {
        let temp = []
        if (selectedRow && selectedRow?.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])

        }
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header-2 d-flex align-items-center">Credits</div>
                {/* temporary hide button */}
                {/* {
                    creatable &&
                    <CustomButton
                        title={<>Buy Credit</>}
                        borderStyle={'1px solid #101010'}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        press={() => setPaymentOpen(true)}
                        paddingInline={50}
                    />
                } */}
            </div>
        )
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value,
        }));
        setPage((prevPage) => (prevPage === 1 ? '1' : 1));
    };

    const planInfo = () => {
        return (
            <div className="mt-3 mb-4 dashboard-card">
                <Grid item md={2.4} sm={6} xs={12}>
                    <div className="subheader-2">Credit Balance</div>
                    <div className="text-bold font-size-18">{creditBalance || 0}</div>
                </Grid>
                {/* temporary hide */}
                {/* <Grid container spacing={2}>
                    <Grid item md={12} className="d-flex align-items-center text-semibold font-size-18">
                        Standard Plan
                        <Label.CustomLabel
                            label={'Current Plan'}
                            color={'#808588'}
                            backgroundColor={'#F5F5F5'}
                            border={"1px solid #F5F5F5"}
                            borderRadius={6}
                            marginLeft={10}
                        />
                    </Grid>
                </Grid>
                <div className="d-flex justify-content-between mb-2 mt-4">
                    <div className="d-flex align-items-center text-semibold">Credit Usage </div>
                    <div className="subheader-2"><span style={{ fontWeight: 600, color: '#031634' }}>{5}</span> / {250} credits</div>
                </div>
                <div className="d-flex align-items-center">
                    <div style={{ width: '100%', color: '#D13536', backgroundColor: '#E9ECF3' }}>
                        <LinearProgress variant="determinate" color="inherit" value={80} />
                    </div>
                </div>
                <div className="subheader-2 mt-2">Total credits: {20} credits per month</div> */}
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !creditListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {planInfo()}
                    <div className="mb-3 text-bold font-size-16 d-flex justify-content-between align-items-center">
                        Credit Balance History
                        <div>
                            <CustomSelect2
                                module={'Type'}
                                value={filterObject?.date_range || '-1'}
                                data={Helpers?.creditDateOptions}
                                placeholder={'All time'}
                                onChange={(e) => handleFilterChange('date_range', e)}
                                startAdornment={<div className="subheader-2" style={{ marginRight: 5 }}>Type: </div>}
                            />
                        </div>


                    </div>
                    <Table
                        header={header}
                        data={creditListing?.data || [{ status: 'draft' }]}
                        pageSize={length}
                        totalPage={creditListing?.data?.last_page}
                        getLengthPage={getLengthPage}
                        customToolsBar={true}
                        setCheckedAll={setCheckedAll}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        checkedAll={checkedAll}
                        sort={sort}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={creditListing?.last_page || 1}
                    />
                </Container>
                <AppDialog
                    open={confirmPaymentOpen}
                    close={() => setConfirmPaymentOpen(false)}
                    title={'Make Payment'}
                    positiveTitle={'Pay now'}
                    positivePress={() => { }}
                    width={'40%'}
                >
                    <Grid container spacing={2}>
                        <Grid item sm={6} color={'#808588'}>Credits</Grid>
                        <Grid item sm={6} className="subheader-2 d-flex justify-content-end">10 credits</Grid>
                        <Grid item sm={6} color={'#808588'}>Total</Grid>
                        <Grid item sm={6} className="text-bold font-size-18 d-flex justify-content-end">$9.00</Grid>
                    </Grid>
                    <Divider className="my-3" />
                    <div className="text-bold font-size-16">Payment Method</div>
                    <div className="mt-3">
                        {
                            paymentTypeList.map((type, index) => (
                                <div className="d-flex align-items-center py-1 dashboard-card px-4 mb-3" style={{}}>
                                    <FormControlLabel
                                        checked={selectedPayment === type.value}
                                        value={selectedPayment === type.value}
                                        onClick={() => setSelectedPayment(type.value)}
                                        key={index}
                                        style={{ fontFamily: 'FunnelSans', fontSize: 14, marginBottom: 0 }}
                                        control={<Radio
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: "#1D1B1B",
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 20,
                                                },

                                            }} />}
                                    />
                                    <div className="mx-1">{type.label}</div>
                                </div>
                            ))
                        }
                    </div>
                </AppDialog>
                <AppDialog
                    open={paymentOpen}
                    close={() => setPaymentOpen(false)}
                    title={'Make Payment'}
                    positiveTitle={'Pay now'}
                    positivePress={() => { setConfirmPaymentOpen(true); setPaymentOpen(false); }}
                >
                    <Grid container spacing={2}>
                        {
                            creditList.map((credit, index) => (
                                <Grid item lg={4} md={6} sm={12} xs={12}>

                                    <div className={`clickable ${selectedCredit === credit?.id ? 'dashboard-selected-card' : 'dashboard-card'}`} onClick={() => setSelectedCredit(credit?.id)}>
                                        <Grid container>
                                            <Grid item sm={10}>
                                                <div className="text-bold font-size-20">{credit.label}</div>
                                                <div>CREDITS</div>
                                            </Grid>
                                            <Grid item sm={2} className="d-flex align-items-center text-bold">
                                                ${credit.price}
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            ))
                        }
                    </Grid>
                    <Divider className="my-3" />
                    <Grid container spacing={2}>
                        <Grid item sm={6} color={'#808588'}>Credits</Grid>
                        <Grid item sm={6} className="subheader-2 d-flex justify-content-end">10 credits</Grid>
                        <Grid item sm={6} color={'#808588'}>Total</Grid>
                        <Grid item sm={6} className="text-bold font-size-18 d-flex justify-content-end">$9.00</Grid>
                    </Grid>
                </AppDialog>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Layout, Credit }) {
    return {
        userPermission: Login.permissionArry,
        leftSideBarType: Layout?.leftSideBarType,
        creditBalance: Credit?.creditListing?.balance,
        creditListing: Credit?.creditListing?.data,
    };
}

export default connect(mapStateToProps)(Credit);
